import React from 'react';
import {
  CModal,
  ModalOverlay,
  ModalContent,
  CModalHeader,
  CModalFooter,
  CModalBody,
  ModalCloseButton,
  Text,
  Button,
} from '@televet/kibble-ui';
import { PersistedStateKeys } from 'shared/enums/PersistedStateKeys';
import useUpdateCurrentClinic from 'shared/hooks/useUpdateCurrentClinic';
import { useHistory } from 'react-router-dom';
import usePersistedState from 'shared/hooks/usePersistedState';

export enum PageType {
  Form = 'form',
  Setting = 'page',
}

interface IUnsavedFormChangesModal {
  isOpen: boolean;
  pageType?: PageType;
  onClose: () => void;
  onConfirm: () => void;
}

const UnsavedFormChangesModal = ({
  isOpen,
  onClose,
  onConfirm,
  pageType,
}: IUnsavedFormChangesModal): JSX.Element | null => {
  const { updateCurrentClinic } = useUpdateCurrentClinic();
  const history = useHistory();
  const [, setNewClinicId] = usePersistedState(PersistedStateKeys.NewClinic, { id: '' });

  const onClickCancel = (): void => {
    setNewClinicId({ id: '' });
    onClose();
  };

  const onClickConfirm = async (): Promise<void> => {
    const newClinicId = JSON.parse(localStorage.getItem(PersistedStateKeys.NewClinic) || '');

    if (!!newClinicId.id) {
      await updateCurrentClinic(newClinicId.id);
      const [redirectTo] = history.location.pathname.match(/^\/(settings.*|[a-z]+)\/?/) || [];
      if (redirectTo) {
        history.push(redirectTo);
      }
      setNewClinicId({ id: '' });
    } else {
      onConfirm();
    }
  };

  return (
    <CModal size="md" isOpen={isOpen} onClose={onClickCancel}>
      <ModalOverlay />
      <ModalContent>
        <CModalHeader fontSize="3xl" pb={1}>
          Unsaved Changes
        </CModalHeader>
        <ModalCloseButton />
        <CModalBody>
          <Text>
            {`This ${pageType} has unsaved changes. If you leave, your changes will be lost. Do you wish to leave this ${pageType}?`}
          </Text>
        </CModalBody>
        <CModalFooter justifyContent="space-between">
          <Button variant="tertiary" mr={3} onClick={onClickCancel}>
            Cancel
          </Button>
          <Button onClick={onClickConfirm}>Leave</Button>
        </CModalFooter>
      </ModalContent>
    </CModal>
  );
};

export default UnsavedFormChangesModal;
